import {ActionIcon, Anchor, Breadcrumbs, Paper, Text} from "@mantine/core";
import {Link as RouterLink, useMatches, useNavigate} from "react-router";
import {IconArrowLeft, IconHome} from "@tabler/icons-react";

export function BreadcrumbsComponent() {
	const matches = useMatches();
	const navigate = useNavigate();

	// Filtra apenas os matches que possuem a propriedade handle.breadcrumb definida
	const breadcrumbs = matches
		.filter((match: any) => Boolean(match.handle?.breadcrumb))
		.map((match: any) => {
			const label =
				typeof match.handle.breadcrumb === "function"
					? match.handle.breadcrumb(match.params)
					: match.handle.breadcrumb;
			return {
				pathname: match.pathname,
				label,
				clickable: match.handle.clickable !== false,
			};
		});

	const canGoBack = window.history.length > 1;

	return (
		<Paper
			withBorder
			p={8}
			radius="sm"
			mb="md"
			className="no-print"
			style={{
				display: "flex",
				alignItems: "center",
				gap: 8,
				opacity: 0.95,
			}}
		>
			{canGoBack && (
				<ActionIcon
					onClick={() => navigate(-1)}
					size="sm"
					variant="subtle"
					color="gray"
					title="Voltar para a página anterior"
				>
					<IconArrowLeft size={18} />
				</ActionIcon>
			)}
			<Breadcrumbs separator="/" separatorMargin="xs">
				<Anchor
					component={RouterLink}
					to="/"
					size="sm"
					style={{display: "flex", alignItems: "center"}}
				>
					<IconHome size={16} style={{marginRight: 4}} />
					Início
				</Anchor>
				{breadcrumbs.map((crumb, index) => {
					const isLast = index === breadcrumbs.length - 1;

					// Evita duplicar o "Início" caso a rota raiz também tenha handle definido
					if (crumb.pathname === "/") return null;

					return isLast ? (
						<Text size="sm" c="dimmed" key={crumb.pathname}>
							{crumb.label}
						</Text>
					) : (
						<Anchor
							component={RouterLink}
							to={crumb.pathname}
							size="sm"
							c={crumb.clickable ? undefined : "dimmed"}
							key={crumb.pathname}
						>
							{crumb.label}
						</Anchor>
					);
				})}
			</Breadcrumbs>
		</Paper>
	);
}
